import {Component, EventEmitter, inject, input, OnInit, Output, signal} from '@angular/core';
import {CartegraphHourRounding, CartegraphHourSettings} from '../../../../../shared/models/cartegraph.model';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';
import {RowWithSelectComponent} from '../../row-with-select/row-with-select.component';


@Component({
  selector: 'app-cartegraph-hours-rounding',
  templateUrl: './cartegraph-hours-settings.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss'],
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    CardContentDirective,
    RowWithSelectComponent
  ],
  standalone: true,
})
export class CartegraphHoursSettingsComponent implements OnInit {

  private fb = inject(UntypedFormBuilder);

  protected isLoading = signal(false);

  @Output()
  settingsChange = new EventEmitter<CartegraphHourSettings>(false);

  hourRoundingOptions: { label: string, value: string }[] = [
    {label: 'Round to quarter hour', value: CartegraphHourRounding.QUARTER_HOUR},
    {label: 'Round to half hour', value: CartegraphHourRounding.HALF_HOUR},
  ];

  processingHourSettings = input<CartegraphHourSettings>();

  uiError: string;
  form: UntypedFormGroup;

  ngOnInit(): void {
    this.initForm();
  }

  canBeSaved() {
    return (this.form?.valid ?? true);
  }

  protected initForm() {

    // init form
    this.form = this.fb.group({
      rounding: this.fb.control(this.processingHourSettings().rounding || CartegraphHourRounding.QUARTER_HOUR, [Validators.required],),
    });

    // notify changes
    this.form.valueChanges.subscribe(() => {
      this.isLoading.set(true);

      const {rounding} = this.form.value;

      const settings = Object.assign({},
        this.processingHourSettings(),
        {rounding} as unknown as CartegraphHourSettings
      );

      // only notify if the object is valid and can be saved
      if (this.canBeSaved()) {
        this.settingsChange.emit(settings);
      }

      this.isLoading.set(false);
    });

  }

}
